__turbopack_context__.v({
  "amountBoxesContainer": "CodonationSelection-module__RRNzWa__amountBoxesContainer",
  "amountInput": "CodonationSelection-module__RRNzWa__amountInput",
  "codonateButton": "CodonationSelection-module__RRNzWa__codonateButton",
  "codonationInputWrapper": "CodonationSelection-module__RRNzWa__codonationInputWrapper",
  "codonationModalContent": "CodonationSelection-module__RRNzWa__codonationModalContent",
  "codonationSelectionContainer": "CodonationSelection-module__RRNzWa__codonationSelectionContainer",
  "fakeButton": "CodonationSelection-module__RRNzWa__fakeButton",
  "introduction": "CodonationSelection-module__RRNzWa__introduction",
  "modal": "CodonationSelection-module__RRNzWa__modal",
  "modalInner": "CodonationSelection-module__RRNzWa__modalInner",
  "openCodonationModalButton": "CodonationSelection-module__RRNzWa__openCodonationModalButton",
  "organisation": "CodonationSelection-module__RRNzWa__organisation",
  "organisationTeaser": "CodonationSelection-module__RRNzWa__organisationTeaser",
  "predefinedAmountBox": "CodonationSelection-module__RRNzWa__predefinedAmountBox",
  "predefinedAmountContainer": "CodonationSelection-module__RRNzWa__predefinedAmountContainer",
  "predefinedImage": "CodonationSelection-module__RRNzWa__predefinedImage",
  "predefinedImageWrapper": "CodonationSelection-module__RRNzWa__predefinedImageWrapper",
});
